module.exports = "/static/media/collection.883c6c2a.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/collection.svg
// module id = 1488
// module chunks = 0